import { Center, Text } from '@chakra-ui/react'
import type { FC } from 'react'

import CardSection from '@app/shared/cards/components/cardSection'
import type { CardSize } from '@app/types'

interface CardRegressionScoreProps {
  regressionScore?: number | null
  regressionScoreType?: string | null
  size: CardSize
}

const CardRegressionScore: FC<CardRegressionScoreProps> = ({ regressionScore, regressionScoreType, size }) => {
  if (!regressionScore || !regressionScoreType) {
    return null
  }

  const regressionScoreTypeDisplay = (scoreType: string) => {
    if (scoreType === 'dependent') {
      return 'Variability explained'
    } else if (scoreType === 'independent') {
      return 'Explanatory power'
    }
    return scoreType
  }

  const regressionScoreDisplay = (score: number) => (score * 100).toFixed(2)

  return (
    <CardSection size={size}>
      <Center>
        <Text fontWeight="bold">
          {regressionScoreDisplay(regressionScore)}% {regressionScoreTypeDisplay(regressionScoreType)}
        </Text>
      </Center>
    </CardSection>
  )
}

export default CardRegressionScore
